import { createHash } from 'crypto'
import { IGenericObject } from 'src/types'

const hashValue = (value: string): string => {
  if (!value) return ''
  return createHash('sha256').update(value.toLowerCase().trim()).digest('hex')
}

/**
 * Identifies a user to the Bing UET tag for enhanced conversion tracking
 * @param email User's email address
 * @param phone User's phone number (optional)
 */
export const bingIdentify = (email: string, phone?: string) => {
  if (typeof window === 'undefined' || !window.uetq) return

  const userData: IGenericObject = {
    em: hashValue(email),
  }

  if (phone) {
    userData.ph = hashValue(phone)
  }

  window.uetq.push('set', { pid: userData })
}

/**
 * Tracks a lead conversion event in Bing Ads
 * @param value Conversion value in USD
 */
export const bingTrackConversion = (value: number) => {
  if (typeof window === 'undefined' || !window.uetq) return

  window.uetq.push('event', 'submit_lead_form', {
    revenue_value: value,
    currency: 'USD',
  })
}
